import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function MarkAsPaidDialog({
  open,
  onClose,
  invoice,
  onMarkPaid,
}) {
  const [datePaid, setDatePaid] = useState("");
  const [paidAmountEUR, setPaidAmountEUR] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && invoice) {
      setDatePaid(new Date().toISOString().slice(0, 10));
      setPaidAmountEUR("");
      setExchangeRate("");
      setError("");
    }
  }, [open, invoice]);

  if (!open) return null;
  if (!invoice)
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Mark Invoice as Paid</DialogTitle>
        <DialogContent sx={{ minWidth: 320, textAlign: "center" }}>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    );

  const isForeign = invoice.currency !== "EUR";

  const handleSubmit = () => {
    if (isForeign && (!paidAmountEUR || isNaN(Number(paidAmountEUR)))) {
      setError("Please enter the EUR amount received.");
      return;
    }
    setError("");
    onMarkPaid({
      datePaid: new Date(datePaid),
      paidAmountEUR: isForeign
        ? parseFloat(paidAmountEUR)
        : invoice.totalAmount,
      paidAmountOriginal: invoice.totalAmount,
      paidCurrency: "EUR",
      exchangeRate: isForeign ? parseFloat(exchangeRate) || null : null,
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Mark Invoice as Paid</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1} sx={{ minWidth: 320 }}>
          <div>
            <b>Invoice amount:</b> {invoice.currency} {invoice.totalAmount}
          </div>
          {isForeign && (
            <>
              <TextField
                label="Amount received (EUR)"
                type="number"
                fullWidth
                value={paidAmountEUR}
                onChange={(e) => setPaidAmountEUR(e.target.value)}
                required
                inputProps={{ min: 0, step: "any" }}
              />
              <TextField
                label="Exchange rate (optional)"
                type="number"
                fullWidth
                value={exchangeRate}
                onChange={(e) => setExchangeRate(e.target.value)}
                helperText="E.g. 1 GBP = ? EUR"
                inputProps={{ min: 0, step: "any" }}
              />
            </>
          )}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Date Paid"
              value={datePaid ? new Date(datePaid) : null}
              onChange={(newValue) => {
                if (newValue) setDatePaid(newValue.toISOString().slice(0, 10));
              }}
              format="dd/MM/yyyy"
              slotProps={{
                textField: {
                  fullWidth: true,
                  InputLabelProps: { shrink: true },
                  sx: { cursor: "pointer" },
                },
              }}
            />
          </LocalizationProvider>
          {error && <div style={{ color: "red", fontSize: 14 }}>{error}</div>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Mark as Paid
        </Button>
      </DialogActions>
    </Dialog>
  );
}
